import React, { useContext, useState } from 'react';

import { Avatar } from '@mui/material';
import { useTranslation } from 'react-i18next';

import EditCompanyButton from './EditCompanyButton/EditCompanyButton';
import StyledTable from '../../../../../shared/components/StyledTable/StyledTable';
import TablePagination from '../../../../../shared/components/TablePagination/TablePagination';
import {
  COMPANIES_UNTIL_PAGINATION,
  DEFAULT_PAGINATOR_OPTIONS,
  DEFAULT_PAGINATOR_STATE
} from '../../../../../shared/constants/settings';
import { SECTION_CONFIGURATION } from '../../../../../shared/constants/tagManager';
import { CompanyContext } from '../../../../../shared/context/company/companyContext';
import { IUserCompany } from '../../../../../shared/interfaces/businessData';
import { TRANSLATIONS_SETTINGS } from '../../../../../shared/translations/settings';
import { getInitialsLetters, toTitleCase } from '../../../../../shared/utils/utils';

import './EditCompanyCard.scss';

const COMPANY_TABLE_COLUMNS = [
  {
    name: TRANSLATIONS_SETTINGS.businessData.company,
    key: 'name',
    class: '',
    render: (company: IUserCompany) => {
      return (
        <div className="company-row">
          <Avatar className="company-edit-avatar" style={{ backgroundImage: `url("${company.image}")` }}>
            {!company.image && getInitialsLetters(company.name, ' ')}
          </Avatar>
          <p>{toTitleCase(company.name)}</p>
        </div>
      );
    }
  },
  {
    name: TRANSLATIONS_SETTINGS.businessData.lastUpdate,
    key: 'updatedAt',
    class: 'table-hide-mobile table-align-center'
  },
  {
    name: '',
    key: '',
    class: 'table-hide-tablet table-align-right',
    render: (company: IUserCompany) => {
      return <EditCompanyButton company={company} />;
    }
  }
];

const EditCompanyCard = () => {
  const [paginatorState, setPaginatorState] = useState<number>(DEFAULT_PAGINATOR_STATE);
  const [actualPage, setActualPage] = useState<number>(0);

  const { holding } = useContext(CompanyContext);

  const { t } = useTranslation();

  const paginatedCompanies = () => {
    const from = actualPage * paginatorState;
    const to = from + paginatorState;
    return holding.companies.slice(from, to);
  };

  return (
    <>
      <div className="settings-organization-ne-card">
        <div className="edit-company-ne-header">
          <div className="title">{t(TRANSLATIONS_SETTINGS.businessData.company)}</div>
        </div>
        <div className="edit-company-table-ne-container">
          <StyledTable
            columns={COMPANY_TABLE_COLUMNS}
            data={paginatedCompanies()}
            error={false}
            showMore={false}
            fixedHeight={true}
          />
        </div>
      </div>
      {holding.companies.length > COMPANIES_UNTIL_PAGINATION && (
        <div className="company-paginator">
          <TablePagination
            rowsPerPageOptions={DEFAULT_PAGINATOR_OPTIONS}
            rowsPerPage={paginatorState}
            count={holding.companies.length}
            actualPage={actualPage}
            onPageChange={setActualPage}
            onRowsPerPageChange={setPaginatorState}
            sectionPage={SECTION_CONFIGURATION}
            marginTop={20}
          />
        </div>
      )}
    </>
  );
};

export default EditCompanyCard;
